export default __webpack_public_path__ + "static/media/ingles_3.0d31fc74.jpg";